function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 3.31501C0 1.67747 1.32749 0.349976 2.96504 0.349976H7.74181L12.6434 5.25153V13.3849C12.6434 15.0225 11.3159 16.35 9.67832 16.35H2.96504C1.32749 16.35 0 15.0225 0 13.3849V3.31501ZM2.96504 1.80452C2.13082 1.80452 1.45455 2.48079 1.45455 3.31501V13.3849C1.45455 14.2192 2.13081 14.8954 2.96504 14.8954H9.67832C10.5125 14.8954 11.1888 14.2192 11.1888 13.3849V6.28005H9.67832C8.04078 6.28005 6.71329 4.95255 6.71329 3.31501V1.80452H2.96504ZM8.16783 2.83304L10.1603 4.8255H9.67832C8.8441 4.8255 8.16783 4.14923 8.16783 3.31501V2.83304Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.41958 9.63669H8.22378V8.46187H4.41958V9.63669ZM2.96504 8.46187C2.96504 7.65854 3.61626 7.00732 4.41958 7.00732H8.22378C9.0271 7.00732 9.67832 7.65854 9.67832 8.46187V12.2661C9.67832 13.0694 9.0271 13.7206 8.22378 13.7206H4.41958C3.61626 13.7206 2.96504 13.0694 2.96504 12.2661V8.46187ZM8.22378 11.0912L8.22378 12.2661L4.41958 12.2661V11.0912H8.22378Z"
});

function SvgExcelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/ExcelIcon.3700a881.svg";
export { ForwardRef as ReactComponent };